import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalPrintshopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_printshop"}/>
}
